<template>
  <v-snackbar v-model="isActive"
              transition="scroll-x-reverse-transition"
              timeout="-1"
              :color="color"
              class="d-flex align-end justify-end pa-0 mb-5"
              :width="$device.isMobile ? '100%' : '250px'"
              @update:modelValue="close">
    <template v-slot:actions>
      <v-icon icon="mdi-close" @click="isActive = false"/>
    </template>

    <suspense>
      <v-sheet class="d-flex align-center"
               elevation="0"
               :color="color"
               :width="$device.isMobile ? '100%' : '250px'"
               :data-cy="`toast-${toastType}`">
        <v-icon size="large" :icon="icon"/>
        <span class="text-subtitle-1 font-weight-bold ml-4"
              style="line-height: 22px">
          {{ message }}
        </span>
      </v-sheet>
    </suspense>
  </v-snackbar>
</template>
<script lang="ts" setup>
import type {ToastType} from "~/composables/openToast";

const isActive = ref(true)
const {close, toastType} = defineProps<{
  close: (returnValue?: any) => void
  toastType: ToastType,
  message: string
}>()

const color = computed(() => toastType === 'success' ? '#02be8a' : '#FF600A')
const icon = computed(() => toastType === 'success' ? 'mdi-check' : 'mdi-alert-outline')
</script>
